//----------- IMPORTAÇÕES -----------//
// Lead Page com importação de CSV avançada com preview e mapeamento
import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext"
import { LeadsContext } from "./context/LeadsContext";
import { loadLeadsService, loadTagsService, loadIntegrationsService } from "./services";
import { Main } from "./components"



//----------- EXPORTAÇÃO DA PÁGINA LEADS ---------//
export default function Leads() {



  //----------- CRIAÇÃO DE HOOKS -----------//
  const { leads, setLeads } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { search, setSearch } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { statusFilter, setStatusFilter } = useContext(LeadsContext);
  const { tagFilter, setTagFilter } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { totalLeads, setTotalLeads } = useContext(LeadsContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)
  const { tagsAvailable, setTagsAvailable } = useContext(LeadsContext);
  const { integrations, setIntegrations } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //------------ USE EFFECT DE INICIALIZAÇÃO ---------//
  useEffect(() => {
    // handleLoadLeads(currentPage, itemsPerPage);
    handleLoadTags();
    handleLoadLeads(currentPage, itemsPerPage);
    handleLoadIntegrations()
  }, []);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE LOAD LEADS ------------//
  // Responsável por carregar as leads do Banco de Dados via API
  // É utilizada na inicialização da página e a cada troca de páginas de lead
  // Armazena as leads no Estado "Leads"
  // Armazena o total de leads no Estado "TotalLeads"
  // Inicializa o Estado "PáginaAtual" 
  async function handleLoadLeads(page = 1, limit = itemsPerPage, term = (search ? search : "")) {
    const offset = (page - 1) * limit;
    setIsLoading(true);
    const response = await loadLeadsService(limit, offset, term, statusFilter, tagFilter, integrationsFilter);
    if (response) {
      console.log(response.data.clientes);
      setLeads(response.data.clientes);
      setTotalLeads(response.data.total_clientes);
      setCurrentPage(page);
    }
    setIsLoading(false);
  };



  //------------ FUNÇÃO ASSÍNCRONA HANDLE LOAD TAGS ------------//
  // Responsável por carregar as Tags do Banco de Dados via API
  // Armazena a lista de tags disponíveis no Estado "TagsDisponiveis"
  async function handleLoadTags() {
    setIsLoading(true);
    const response = await loadTagsService("");
    if (response) {
      setTagsAvailable(response.data);
    }
    setIsLoading(false);
  };



  //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
  // Nesta função, é requisitado à API as TAGS armazenadas.
  // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
  async function handleLoadIntegrations() {
    const response = await loadIntegrationsService();
    if (response) {
      setIntegrations(response.data);
    }
  };



  // async function handleLoadLeadsByTransactions() {
  //   setIsLoading(true);
  //   const response = await loadLeadsByTransationsService();
  //   console.log(response)
  //   if (response) {
  //     setLeads(response.data.clientes);
  //     setTotalLeads(response.data.total_clientes);
  //   }
  //   setIsLoading(false);
  // };



  //---------- RETORNO CONDICIONAL DA PÁGINA LEADS ----------//
  return (
    <>
      {isLoading || leads === null ? <Loading /> : <Main />}
    </>
  )
}